import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Redirect } from "react-router";
import { GlobalContext } from "../../Context/GlobalState";
import DmtRejectedTransactions from "./DmtRejectedTransactions";
const DMTRejectedTransactionsReport = () => {
  return (
    <GlobalContext.Consumer>
      {(context) =>
        context.user == null || context.user.UserType !== "2" ? (
          <Redirect to="/" />
        ) : (
          <div style={{ margin: "10px" }}>
            <div
              style={{
                display: "flex",
                background: "#30363e",
                color: "#FFF",
                padding: "10px",
                justifyContent: "space-between",
              }}
            >
              <strong>DMT Rejected Transactions </strong>
            </div>
            <DmtRejectedTransactions />
          </div>
        )
      }
    </GlobalContext.Consumer>
  );
};

export default DMTRejectedTransactionsReport;
